export function isValidFormatJSON(stringJSON: string): boolean {
  return !!stringJSON && /^[\],:{}\s]*$/.test(stringJSON.replace(/\\["\\\/bfnrtu]/g, '@').
    replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').
    replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
}
